'use strict'
/* 当前登录用户维度的通用配置接口。

   /user/ 前缀下的业务接口按功能分散在各自模块里（小红书账号在 login.js、签到在 team.js），
   这里只放与具体业务无关、面向登录用户本身的配置查询。

   为什么不并进 app.js：app.js 要用 utils/menuDisplayConfig 过滤菜单，
   而后者要调本接口，写在一起就是循环依赖。

   @date 2026-09-09
   @ai-generated true
   @ai-tool Claude Code */
import httpRequest from '../request/indexBase'

/**
 * 查询当前登录用户的菜单显示配置。
 *
 * data 形如 { show: true, phone: '13800138000' }：
 * - show：灰度演示入口（demoOnly）是否对该用户可见；
 * - phone：演示站识别用户身份用的手机号，拼在外链的 phone 查询参数上。
 *
 * 由后端按登录态判定，前端不再自己比对名单。
 */
export function checkMenuDisplayConfig() {
  return httpRequest.get({
    url: `/user/menu-display-config/check`
  })
}
